import { EstablishmentsArgs } from '@/modules/accredited-establishments/api'
import {
  AccreditedGender,
  AppointmentType,
  FilterItem,
  EstablishmentCategory
} from '@/modules/accredited-establishments/api/types'
import {
  isDefaultSearch,
  makeFiltersArgs
} from '@/modules/accredited-establishments/functions'

interface SearchFiltersBaseProps {
  categories: EstablishmentCategory[]
  specialty?: FilterItem
  subSpecialty?: FilterItem
  gender?: AccreditedGender
  appointmentType?: AppointmentType
  plan?: FilterItem
  address?: FilterItem
  providerName?: string
  lat?: string
  lon?: string
  radiusInMeters?: number
}

interface SearchFiltersWithLatLonProps extends SearchFiltersBaseProps {
  lat: string
  lon: string
  address?: undefined
}

interface SearchFiltersWithAddressProps extends SearchFiltersBaseProps {
  address: FilterItem
  lat?: undefined
  lon?: undefined
}

type SearchFiltersProps =
  | SearchFiltersWithLatLonProps
  | SearchFiltersWithAddressProps

type MakeGetEstablishmentsArgsProps = {
  searchFilters: SearchFiltersProps
  enabled: boolean
  hasDefaultSearchProps?: boolean
}

const makeGetEstablishmentsArgs = ({
  searchFilters,
  enabled,
  hasDefaultSearchProps = true
}: MakeGetEstablishmentsArgsProps): EstablishmentsArgs => {
  const filter = makeFiltersArgs({
    categories: searchFilters.categories,
    specialty: searchFilters.specialty,
    subSpecialty: searchFilters.subSpecialty,
    gender: searchFilters.gender,
    appointmentType: searchFilters.appointmentType,
    plan: searchFilters.plan,
    providerName: searchFilters.providerName
  })

  const defaultSearch = hasDefaultSearchProps
    ? isDefaultSearch({
        categoryIds: filter.categoryIds,
        specialtyId: filter.specialtyId,
        planId: filter.siteAccreditedNetworkId,
        providerName: filter.providerName,
        lat: searchFilters.lat,
        lon: searchFilters.lon,
        radiusInMeters: searchFilters.radiusInMeters
      })
    : undefined

  const baseArgs = {
    ...filter,
    radiusInMeters: searchFilters.radiusInMeters?.toString(),
    isDefaultSearch: defaultSearch,
    enabled
  }

  const args: EstablishmentsArgs = searchFilters.address
    ? {
        ...baseArgs,
        placeId: searchFilters.address?.value
      }
    : {
        ...baseArgs,
        lat: searchFilters.lat,
        lon: searchFilters.lon
      }

  return args
}

export type {
  SearchFiltersWithLatLonProps,
  SearchFiltersWithAddressProps,
  SearchFiltersProps
}

export { makeGetEstablishmentsArgs }
